export enum SwitchLabelPosition {
    Before,
    After
}